import React from 'react';
import ModalBody from './modal_body';

const Modal = ({
  modalId,
  label,
  title,
  member,
  setMemberRole,
  memberRole,
  subtitle = '',
  handleClick = () => null
}) => {
  const memberName = member
    ? member.displayName
    : 'Member';

  const handleSubtitle = () =>
    subtitle === 'role' ? (
      <p>
        Please choose role for <span className="fw-bold">{memberName}</span>
      </p>
    ) : null;

  return (
    <div
      className="modal fade"
      id={modalId}
      tabIndex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header flex-md-column align-items-start border-0 pb-4 ps-4">
            <p className="modal-title h3" id="exampleModalLabel">
              {title}
            </p>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
            {handleSubtitle(memberName)}
          </div>
          <div className="modal-body border-0 py-0 px-4">
            <ModalBody
              memberRole={memberRole}
              member={member}
              modalId={modalId}
              setMemberRole={setMemberRole}
              memberName={memberName}
            />
          </div>
          <div className="modal-footer justify-content-center py-4 px-0 border-0">
            <button
              type="button"
              className="btn btn-primary col-md-6"
              data-bs-dismiss="modal"
              onClick={handleClick}
            >
              {label}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
